import React from "react";
import { Car } from "lucide-react";

export const Logo = ({ size = 40, withText = true }) => {
    return (
        <div className="flex items-center gap-3" data-testid="autopilot-logo">
            <div
                className="flex items-center justify-center rounded-xl"
                style={{
                    width: size,
                    height: size,
                    background: "var(--ap-blue)",
                    boxShadow: "0 8px 24px -8px rgba(37,99,235,0.6)",
                }}
            >
                <Car size={size * 0.55} strokeWidth={2.2} className="text-white" />
            </div>
            {withText && (
                <span
                    className="font-bold tracking-tight text-white"
                    style={{ fontSize: size * 0.7 }}
                >
                    AutoPilot
                </span>
            )}
        </div>
    );
};
